<template>

    <div class="loading" >
        <div class="load-container" :style="{backgroundColor: bg ? '#0008' : '' }">
            <!-- <svg xmlns="http://www.w3.org/2000/svg" width="4em" height="4em" viewBox="0 0 24 24"><path fill="currentColor" d="M12 2A10 10 0 1 0 22 12A10 10 0 0 0 12 2Zm0 18a8 8 0 1 1 8-8A8 8 0 0 1 12 20Z" opacity="0.5"/><path fill="currentColor" d="M20 12h2A10 10 0 0 0 12 2V4A8 8 0 0 1 20 12Z"><animateTransform attributeName="transform" dur="1s" from="0 12 12" repeatCount="indefinite" to="360 12 12" type="rotate"/></path></svg> -->
            <svg v-if="loading" xmlns="http://www.w3.org/2000/svg" width="4em" height="4em" viewBox="0 0 24 24">
                <path fill="#fff" d="M12 2A10 10 0 1 0 22 12A10 10 0 0 0 12 2Zm0 18a8 8 0 1 1 8-8A8 8 0 0 1 12 20Z" opacity="0.5"/><path fill="var(--amarelo)" d="M20 12h2A10 10 0 0 0 12 2V4A8 8 0 0 1 20 12Z">
                    <animateTransform attributeName="transform" dur="1s" from="0 12 12" repeatCount="indefinite" to="360 12 12" type="rotate"/>
                </path>
            </svg>
            <p :style="{color: textColor}">{{ message }}</p>
        </div>  
    </div>

</template>

<script>

export default {
    name: 'Loading',
    props: {
       loading: {
           type: Boolean,
           default: false
       },

    //    styled: {
    //        type: Object,
    //           default: {
    //             backgroundColor: '#0008',
    //             top: '4em',
    //             height: '100%',
    //           }
    //      },

       outService: {
           type: Boolean,
           default: false
       },
        message: {
            type: String,
            default: 'A carregar...'
        },
        bg: {
            type: Boolean,
            default: true
        },
        textColor: {
            type: String,
            default: '#fff'
        }

    }
}

</script>


<style scoped>

    .loading{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 100%;
        
        position: absolute;
        top: 4em;
        left: 0;
        z-index: 3;
    }

    .load-container{
        border-radius: 8px;
        background-color: #a1a1a1;
        width: 100%;
        height: 100%;
        
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        
    }
        
    .load-container{
        font-size: 1.5em;
    }

    p{
        text-align: center;
    }

</style>